var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchangecoupon-wrapper", attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "van-cell-group",
                  [
                    _c("van-field", {
                      attrs: {
                        label: "兑换码：",
                        required: "",
                        placeholder: "请输入8位兑换码",
                        "error-message": _vm.errMessage
                      },
                      on: { blur: _vm.onBlur },
                      model: {
                        value: _vm.couponCode,
                        callback: function($$v) {
                          _vm.couponCode = $$v
                        },
                        expression: "couponCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-wrapper", on: { click: _vm.submit } },
              [
                _c("van-button", { attrs: { round: "", type: "danger" } }, [
                  _vm._v("立即兑换")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "popup-wrapper" },
          [
            _c(
              "van-popup",
              {
                model: {
                  value: _vm.showPopup,
                  callback: function($$v) {
                    _vm.showPopup = $$v
                  },
                  expression: "showPopup"
                }
              },
              [
                _c("img", {
                  staticClass: "icon",
                  attrs: {
                    src: require("../assets/img/incoupon/Shape@2x.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("h1", { staticClass: "title" }, [_vm._v("兑换成功")]),
                _vm._v(" "),
                _c("span", { staticClass: "desc" }, [
                  _vm._v(_vm._s(_vm.limit) + "s后跳转到我的优惠券")
                ])
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "instruction-wrapper" }, [
      _c("ul", { staticClass: "instr-ul-wrapper" }, [
        _c("li", { staticClass: "list-item" }, [
          _vm._v("1.兑换码获取：由8位数字和字母组合而成的优惠券兑换规则。")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "list-item" }, [
          _vm._v(
            "2.兑换码使用：在当前页面输入兑换码即可兑换相应优惠券。一个兑换码只能兑换一张优惠券，不可重复使用。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }